// Generated by protoc-gen-vendasta-ts — DO NOT EDIT
/* eslint-disable */
import { defer } from 'rxjs';
import { map } from 'rxjs/operators';
import { approveProposedActionRequestToJson, approveProposedActionResponseFromJson, getSessionEventRequestToJson, getSessionEventResponseFromJson, getSessionRequestToJson, getSessionResponseFromJson, listProposedActionsRequestToJson, listProposedActionsResponseFromJson, listSessionsRequestToJson, listSessionsResponseFromJson, rejectProposedActionRequestToJson, rejectProposedActionResponseFromJson } from './codec';
import { fetchRpc } from '@vendasta/protos/fetch-transport';
import { getGlobalTransport } from '@vendasta/protos/transport';
export async function getSession(request) {
    const raw = await fetchRpc('ai_assistants.v1alpha1.SessionService/GetSession', getSessionRequestToJson(request));
    return getSessionResponseFromJson(raw);
}
export function getSession$(request, options) {
    return defer(() => getSessionWithTransport$(getGlobalTransport(), request, options));
}
export function getSessionWithTransport$(transport, request, options) {
    return transport
        .post('ai_assistants.v1alpha1.SessionService/GetSession', getSessionRequestToJson(request), options)
        .pipe(map(resp => getSessionResponseFromJson(resp)));
}
export async function getSessionEvent(request) {
    const raw = await fetchRpc('ai_assistants.v1alpha1.SessionService/GetSessionEvent', getSessionEventRequestToJson(request));
    return getSessionEventResponseFromJson(raw);
}
export function getSessionEvent$(request, options) {
    return defer(() => getSessionEventWithTransport$(getGlobalTransport(), request, options));
}
export function getSessionEventWithTransport$(transport, request, options) {
    return transport
        .post('ai_assistants.v1alpha1.SessionService/GetSessionEvent', getSessionEventRequestToJson(request), options)
        .pipe(map(resp => getSessionEventResponseFromJson(resp)));
}
export async function listSessions(request) {
    const raw = await fetchRpc('ai_assistants.v1alpha1.SessionService/ListSessions', listSessionsRequestToJson(request));
    return listSessionsResponseFromJson(raw);
}
export function listSessions$(request, options) {
    return defer(() => listSessionsWithTransport$(getGlobalTransport(), request, options));
}
export function listSessionsWithTransport$(transport, request, options) {
    return transport
        .post('ai_assistants.v1alpha1.SessionService/ListSessions', listSessionsRequestToJson(request), options)
        .pipe(map(resp => listSessionsResponseFromJson(resp)));
}
export async function approveProposedAction(request) {
    const raw = await fetchRpc('ai_assistants.v1alpha1.SessionService/ApproveProposedAction', approveProposedActionRequestToJson(request));
    return approveProposedActionResponseFromJson(raw);
}
export function approveProposedAction$(request, options) {
    return defer(() => approveProposedActionWithTransport$(getGlobalTransport(), request, options));
}
export function approveProposedActionWithTransport$(transport, request, options) {
    return transport
        .post('ai_assistants.v1alpha1.SessionService/ApproveProposedAction', approveProposedActionRequestToJson(request), options)
        .pipe(map(resp => approveProposedActionResponseFromJson(resp)));
}
export async function rejectProposedAction(request) {
    const raw = await fetchRpc('ai_assistants.v1alpha1.SessionService/RejectProposedAction', rejectProposedActionRequestToJson(request));
    return rejectProposedActionResponseFromJson(raw);
}
export function rejectProposedAction$(request, options) {
    return defer(() => rejectProposedActionWithTransport$(getGlobalTransport(), request, options));
}
export function rejectProposedActionWithTransport$(transport, request, options) {
    return transport
        .post('ai_assistants.v1alpha1.SessionService/RejectProposedAction', rejectProposedActionRequestToJson(request), options)
        .pipe(map(resp => rejectProposedActionResponseFromJson(resp)));
}
export async function listProposedActions(request) {
    const raw = await fetchRpc('ai_assistants.v1alpha1.SessionService/ListProposedActions', listProposedActionsRequestToJson(request));
    return listProposedActionsResponseFromJson(raw);
}
export function listProposedActions$(request, options) {
    return defer(() => listProposedActionsWithTransport$(getGlobalTransport(), request, options));
}
export function listProposedActionsWithTransport$(transport, request, options) {
    return transport
        .post('ai_assistants.v1alpha1.SessionService/ListProposedActions', listProposedActionsRequestToJson(request), options)
        .pipe(map(resp => listProposedActionsResponseFromJson(resp)));
}
